var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Route } from "react-router";
import { Link } from "react-router-dom";
import { Button, Dimmer, Form, Loader, Message, } from 'semantic-ui-react';
import { RnaCatalogType } from "../../admin/EditOrderKit";
import { AppPaths, UiConfigContext } from "../../AppConfig";
import rnaLogo from '../../images/logo_RNA.png';
import { CatalogMode, postJsonWithAuthn } from "../../RequestHelpers";
import { RelevantCatalogType } from "../automated-pro/RnaCatalog";
import { RnaCatalogLoader } from "../automated-pro/RnaCatalogLoader";
import CornerLogoContainer from "../CornerLogoContainer";
import { buildEditFormStateHandlerForComponent } from "../FormState";
import EditKitForm, { CART_PRICE_PATH, defaultFormState, } from "./EditKitForm";
import { ManualGoldIfKitPrice, ManualProPrice, RnaFishKitPrice, SecondaryIfKitPrice } from "./KitModel";
import { LoadWrapper } from "./LoadWrapper";
var NewRnaFishKitPage = /** @class */ (function (_super) {
    __extends(NewRnaFishKitPage, _super);
    function NewRnaFishKitPage(props) {
        return _super.call(this, props) || this;
    }
    NewRnaFishKitPage.prototype.render = function () {
        var _this = this;
        var renderer = function (catalog) {
            return React.createElement(NewKitContent, { legacy: _this.props.legacy, catalog: catalog, adminUser: _this.props.adminUser, legacyUser: _this.props.legacyUser });
        };
        return React.createElement(LoadWrapper, { loader: new RnaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Initial, RnaCatalogType.RnaFish), render: renderer });
    };
    return NewRnaFishKitPage;
}(React.PureComponent));
export default NewRnaFishKitPage;
var NewKitContent = /** @class */ (function (_super) {
    __extends(NewKitContent, _super);
    function NewKitContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onAddToCart = addToCartHandlerBuilder(function (callback) {
            _this.setState({
                loading: true,
                addToCartButtonPressed: true
            }, callback);
        }, function () { return JSON.stringify(EditKitForm.serializeRnaFishKit(_this.state.formState)); }, function (history) {
            _this.setFormState(function () { return ({
                errors: [],
            }); }, function () {
                _this.setState({
                    loading: false,
                }, function () {
                    history.push('/cart');
                });
            });
        }, function (errors) {
            _this.setFormState(function () { return ({
                errors: errors.errors,
            }); }, function () {
                _this.setState({
                    loading: false,
                });
            });
        });
        _this.setFormState = buildEditFormStateHandlerForComponent('formState', _this);
        // Helper to allow us to access Route info in a click handler
        _this.addToCartButton = function (props) {
            var onClick = function () {
                // tslint tells me that inline lambdas in props are slow, so we do it here...?
                _this.onAddToCart(props.history);
            };
            return React.createElement(Button, { icon: 'cart plus', label: 'Add to cart', labelPosition: 'left', onClick: onClick, positive: true });
        };
        _this.state = {
            loading: false,
            formState: defaultFormState(props.catalog, props.legacy),
            addToCartButtonPressed: false
        };
        return _this;
    }
    NewKitContent.prototype.render = function () {
        var pageContents = React.createElement("div", { id: "non-header-portion" },
            React.createElement(React.Fragment, null,
                React.createElement("h1", { className: 'branded' }, this.props.legacy ? "HCR™ RNA-FISH (v3.0) Kit" : "HCR™ Gold RNA-FISH Kit"),
                React.createElement("h2", { className: 'branded' }, this.props.legacy ? "Multiplex, quantitative, high-resolution RNA imaging"
                    : "The gold standard for multiplex, quantitative, high-resolution RNA imaging"),
                React.createElement("span", { style: { float: 'right', marginTop: '2rem' } }, this.props.legacy ?
                    React.createElement("a", { href: "https://www.molecularinstruments.com/hcr-v3-protocols" }, "HCR\u2122 (v3.0) Protocols") :
                    React.createElement("a", { href: "https://www.molecularinstruments.com/hcr-gold-protocols" }, "HCR\u2122 Gold User Guides")),
                React.createElement("p", { className: 'branded', style: { width: '50%' } },
                    "Order one ",
                    this.props.legacy ? "HCR™ RNA-FISH (v3.0) kit" : "HCR™ Gold RNA-FISH kit",
                    " per target RNA ",
                    !this.props.legacy ? "(select a different HCR™ Gold Amplifier for each target RNA)" : "(select a different HCR™ Amplifier (v3.0) for each target RNA)",
                    ". The same reagents enable multiplex, quantitative ",
                    this.props.legacy ? "HCR™ RNA Flow Cytometry (v3.0) and HCR™ Northern Blots (v3.0)" :
                        "HCR™ Gold RNA Flow Cytometry and HCR™ Gold Northern Blots",
                    "."),
                React.createElement("br", null),
                !this.props.legacy && (this.props.legacyUser || this.props.adminUser) &&
                    React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                        React.createElement("h2", { className: 'branded' }, "Ordering HCR\u2122 Gold?"),
                        "Please note that HCR\u2122 Gold RNA-FISH kits are not compatible with our previous-generation product line, HCR\u2122 RNA-FISH (v3.0), for which kits are available ",
                        React.createElement("a", { href: AppPaths.LOCAL_NEW_LEGACY_KIT_RNA_FISH }, "here"),
                        ". Learn more at our ",
                        React.createElement("a", { target: "_blank", href: "https://molecularinstruments.com/faq#gold-vs-v3-faq" }, "HCR\u2122 Gold vs HCR\u2122 (v3.0) FAQ"),
                        ". ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                        " ",
                        React.createElement("br", null)),
                this.props.legacy &&
                    React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                        React.createElement("h2", { className: 'branded' }, "Ordering HCR\u2122 Gold?"),
                        "Please note that HCR\u2122 RNA-FISH (v3.0) kits are not compatible with our latest-generation product line, HCR\u2122 Gold RNA-FISH, for which kits are available ",
                        React.createElement("a", { href: AppPaths.LOCAL_NEW_KIT_RNA_FISH }, "here"),
                        ". Learn more at our ",
                        React.createElement("a", { target: "_blank", href: "https://molecularinstruments.com/faq#gold-vs-v3-faq" }, "HCR\u2122 Gold vs HCR\u2122 (v3.0) FAQ"),
                        ". ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                        " ",
                        React.createElement("br", null)),
                React.createElement(UiConfigContext.Consumer, null, function (uiConfig) {
                    if (!uiConfig.authenticated) {
                        return React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                            React.createElement("h2", { className: 'branded' }, "Special Pricing for Academic Users!"),
                            React.createElement(Link, { to: AppPaths.REGISTER }, "Register"),
                            " to see applicable discounts. Special academic pricing is applied to your account automatically once you\u2019re signed in.",
                            React.createElement("br", null),
                            " ",
                            React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                            " ",
                            React.createElement("br", null));
                    }
                    else {
                        return React.createElement(React.Fragment, null);
                    }
                })),
            React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.formState.errors.length > 0 },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.formState &&
                    React.createElement(React.Fragment, null,
                        React.createElement(EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: this.props.catalog, formState: this.state.formState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableNegativeControlProbe: true, enableCustomPrice: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, enableAdminSystems: false, setFormState: this.setFormState, legacy: this.props.legacy, showErrors: this.state.addToCartButtonPressed }),
                        React.createElement("div", null,
                            React.createElement(React.Fragment, null, this.props.legacy ? React.createElement("p", { className: 'branded', style: { width: '50%' } },
                                "Combine with ",
                                React.createElement(Link, { to: AppPaths.LOCAL_NEW_LEGACY_KIT_IHC2 }, "HCR\u2122 2\u00BAIF kits"),
                                " for unified multiplex, quantitative, high-resolution RNA and protein imaging.") : React.createElement("p", { className: 'branded', style: { width: '50%' } },
                                "Combine with ",
                                React.createElement(Link, { to: AppPaths.LOCAL_NEW_KIT_ENCODER }, "HCR\u2122 Gold IF kits"),
                                " for unified multiplex, quantitative, high-resolution RNA and protein imaging.")),
                            React.createElement("div", { style: { float: 'right' } },
                                React.createElement("div", { style: { 'textAlign': 'right' } },
                                    React.createElement(Route, { render: this.addToCartButton }))),
                            React.createElement("div", { style: { clear: 'both' } })))));
        return React.createElement(CornerLogoContainer, { img: rnaLogo, alt: 'RNA logo' }, pageContents);
    };
    return NewKitContent;
}(React.PureComponent));
// Returns a function suitable for being an "add to cart" click handler.
export var addToCartHandlerBuilder = function (beforeRequest, getJson, onSuccess, onError) {
    var path = '/cart/item';
    return function (history) {
        beforeRequest(function () {
            postJsonWithAuthn(path, getJson())
                .then(function (resp) {
                if (resp.ok) {
                    // added to cart; don't do anything more
                    onSuccess(history);
                    resp.json().then(function (r) {
                        tagAddToCart(r);
                    }).catch(function (rej) {
                        console.error("Couldn't track adding to cart: " + rej);
                    });
                    return undefined;
                }
                else {
                    return resp.json();
                }
            }).then(function (resp) {
                if (resp !== undefined) {
                    onError(resp);
                }
            }).catch(function (rej) {
                console.error("Couldn't add to cart: " + rej);
            });
        });
    };
};
// A wrapper that's a class, so you can instanceof check it
var ErrorElements = /** @class */ (function () {
    function ErrorElements(errors) {
        this.errors = errors;
    }
    return ErrorElements;
}());
export { ErrorElements };
var ErrorElementsWithPrices = /** @class */ (function () {
    function ErrorElementsWithPrices(errors, price) {
        this.errors = errors;
        this.price = price;
    }
    return ErrorElementsWithPrices;
}());
export { ErrorElementsWithPrices };
export var ProductType;
(function (ProductType) {
    ProductType["RNA_FISH"] = "rna-fish";
    ProductType["IF"] = "if";
    ProductType["RNA_ISH"] = "rna-ish";
    ProductType["MANUAL_PRO"] = "manual-pro";
    ProductType["MANUAL_GOLD_IF"] = "manual-gold-if";
    ProductType["AUTOMATED_GOLD_IF"] = "automated-gold-if";
})(ProductType || (ProductType = {}));
var isManualProPrice = function (b) {
    return b.kitType === ProductType.MANUAL_PRO;
};
var isRnaFishKitPrice = function (b) {
    return b.kitType === ProductType.RNA_FISH;
};
var isSecondaryIfKitPrice = function (b) {
    return b.kitType === ProductType.IF;
};
var isManualGoldIfKitPrice = function (b) {
    return b.kitType === ProductType.MANUAL_GOLD_IF;
};
var isProKitPrice = function (b) {
    return b.kitType === ProductType.RNA_ISH;
};
var isAutomatedIfPrice = function (b) {
    return b.kitType === ProductType.AUTOMATED_GOLD_IF;
};
export var kitPriceToGoogleAnalyticsItems = function (bp) {
    var items = [];
    if (isRnaFishKitPrice(bp) || bp instanceof RnaFishKitPrice) {
        if (bp.probeSetPriceCents > 0) {
            items.push({
                item_name: 'RNA-FISH Probe set',
                quantity: 1,
                price: bp.probeSetPriceCents / 100.0
            });
        }
        if (bp.amplifierPriceCents > 0) {
            items.push({
                item_name: 'Amplifier',
                quantity: 1,
                price: bp.amplifierPriceCents / 100.0
            });
        }
        if (bp.buffersPriceCents > 0) {
            items.push({
                item_name: 'RNA-FISH Buffers',
                quantity: 1,
                price: bp.buffersPriceCents / 100.0
            });
        }
    }
    else if (isSecondaryIfKitPrice(bp) || bp instanceof SecondaryIfKitPrice) {
        if (bp.probePriceCents > 0) {
            items.push({
                item_name: '2-IHC Probe',
                quantity: 1,
                price: bp.probePriceCents / 100.0
            });
        }
        if (bp.amplifierPriceCents > 0) {
            items.push({
                item_name: 'Amplifier',
                quantity: 1,
                price: bp.amplifierPriceCents / 100.0
            });
        }
        if (bp.buffersPriceCents > 0) {
            items.push({
                item_name: '2-IHC Buffers',
                quantity: 1,
                price: bp.buffersPriceCents / 100.0
            });
        }
    }
    else if (isManualGoldIfKitPrice(bp) || bp instanceof ManualGoldIfKitPrice) {
        if (bp.encoderPriceCents > 0) {
            items.push({
                item_name: 'Encoder Kit',
                quantity: 1,
                price: bp.encoderPriceCents / 100.0
            });
        }
    }
    else if (isManualProPrice(bp) || bp instanceof ManualProPrice) {
        if (bp.probeSetPriceCents > 0) {
            items.push({
                item_name: 'Manual Pro Probe set',
                quantity: 1,
                price: bp.probeSetPriceCents / 100.0
            });
        }
        if (bp.detectPriceCents > 0) {
            items.push({
                item_name: 'Manual Pro Amplifier',
                quantity: 1,
                price: bp.detectPriceCents / 100.0
            });
        }
        if (bp.buffersPriceCents > 0) {
            items.push({
                item_name: 'Manual Pro Buffers',
                quantity: 1,
                price: bp.buffersPriceCents / 100.0
            });
        }
        if (bp.chromogenPriceCents > 0) {
            items.push({
                item_name: 'Manual Pro Chromogen',
                quantity: 1,
                price: bp.chromogenPriceCents / 100.0
            });
        }
    }
    else if (isProKitPrice(bp)) {
        bp.probeSetPriceCents.map(function (pspc) {
            items.push({
                item_name: 'RNA-CISH Probe set',
                quantity: 1,
                price: pspc.price / 100.0
            });
        });
        if (bp.detectPriceCents > 0) {
            items.push({
                item_name: 'RNA-CISH Amplifier',
                quantity: 1,
                price: bp.detectPriceCents / 100.0
            });
        }
    }
    else if (isAutomatedIfPrice(bp)) {
        if (bp.encoderPriceCents > 0) {
            items.push({
                item_name: 'HCR™ HiFi Encoder Kits',
                quantity: 1,
                price: bp.encoderPriceCents / 100.0
            });
        }
        if (bp.detectPriceCents) {
            items.push({
                item_name: 'HCR™ Gold Detect Kit',
                quantity: 1,
                price: bp.detectPriceCents / 100.0
            });
        }
    }
    return items;
};
export function tagAddToCart(r) {
    gtag('event', 'add_to_cart', {
        value: r.kitPrice.subtotalCents / 100.0,
        currency: 'USD',
        items: kitPriceToGoogleAnalyticsItems(r.kitPrice)
    });
}
//# sourceMappingURL=NewRnaFishKitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/NewRnaFishKitPage.js
// module id = 22
// module chunks = 0